import(/* webpackMode: "eager" */ "/mnt/c/shipany/ZestyGen/src/app/[locale]/(chat)/layout.tsx");
